import { render, staticRenderFns } from "./FormulasBlock.vue?vue&type=template&id=5c21cec2&scoped=true"
import script from "./FormulasBlock.vue?vue&type=script&lang=js"
export * from "./FormulasBlock.vue?vue&type=script&lang=js"
import style0 from "./FormulasBlock.vue?vue&type=style&index=0&id=5c21cec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21cec2",
  null
  
)

export default component.exports